<mat-dialog-content class="adap-dialog-content">
  <app-dialog-header [title]="title"></app-dialog-header>
  <ng-container *ngIf="formState$ | async as formState">
    <form novalidate [ngrxFormState]="formState" class="adap-form-container">
      <div class="form-row-2-columns">
        <app-input-container
          label="code"
          labelFor="code"
          [app-input-validation-container]="formState.controls.code"
        >
          <input
            id="code"
            name="code"
            type="text"
            placeholder="enter business unit code"
            class="adap-form-input"
            maxlength="10"
            [ngrxFormControlState]="formState.controls.code"
          />
        </app-input-container>
        <app-input-container
          label="name"
          labelFor="name"
          [app-input-validation-container]="formState.controls.name"
        >
          <input
            id="name"
            name="name"
            type="text"
            placeholder="enter business unit name"
            class="adap-form-input"
            maxlength="100"
            [ngrxFormControlState]="formState.controls.name"
          />
        </app-input-container>
      </div>
      <app-input-container
        label="region"
        [isRequired]="true"
        [characterCounterLength]="formState.controls.region.value?.length ?? 0"
        [characterCounterMaxLength]="REGION_MAX_LENGTH"
        [app-input-validation-container]="formState.controls.region"
      >
        <textarea
          id="region"
          name="region"
          type="text"
          class="adap-form-textarea text-area-container"
          [ngrxFormControlState]="formState.controls.region"
        >
        </textarea>
      </app-input-container>
    </form>
    <div class="dialog-actions">
      <button class="adap-btn-outline" type="button" (click)="closeWindow()">
        cancel
      </button>
      <ng-container>
        <ng-container>
          <button
            class="adap-btn-filled"
            type="button"
            [disabled]="!formState.isValid"
            (click)="save()"
          >
            save
          </button>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
</mat-dialog-content>
